import { com, kotlin } from '@eidu/web'
import FieldData from '../../domain/entity/FieldData'
import KtList = kotlin.collections.KtList
import FieldId = com.eidu.entity.field.FieldId
import NamedLabelFormat = com.eidu.entity.label.NamedLabelFormat
import EntityLabel = com.eidu.entity.label.EntityLabel
import EntityLabelLine = com.eidu.entity.label.EntityLabelLine
import Field = com.eidu.entity.field.Field

export const labelLineToString = (
  { format, argumentFields }: EntityLabelLine,
  availableFields: readonly Field[]
): string => {
  const fieldNames = argumentFields
    .asJsReadonlyArrayView()
    .map((id) => availableFields.find((field) => id.equals(field.id))?.name ?? id.toString())
  return format.toNamedLabelFormat(KtList.fromJsArray(fieldNames)).pattern
}

export const stringToLabelLine = (
  label: string,
  availableFields: readonly FieldData[]
): EntityLabelLine | undefined => {
  const namedFormat = new NamedLabelFormat(label)
  const argumentFieldsOrUndefined = namedFormat.variableNames
    .asJsReadonlyArrayView()
    .map((it) => availableFields.find((field) => field.field.name === it)?.field.id)
  const argumentFields = argumentFieldsOrUndefined.filter((it): it is FieldId => it !== undefined)
  if (argumentFields.length !== argumentFieldsOrUndefined.length) return undefined

  return new EntityLabelLine(namedFormat.indexedFormat, KtList.fromJsArray(argumentFields))
}

export const createEntityLabel = ({
  primaryLabel,
  secondaryLabel,
  fields,
}: {
  primaryLabel?: string
  secondaryLabel?: string
  fields: readonly FieldData[]
}): EntityLabel | undefined => {
  const primary = primaryLabel?.let((it) => stringToLabelLine(it, fields))
  const secondary = secondaryLabel?.let((it) => stringToLabelLine(it, fields))

  if (primary === undefined) return undefined
  else return new EntityLabel(primary, secondary)
}
